import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import PropertyDetailLayout from './PropertyDetail';

export default function PropertyDetailPage() {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [owners, setOwners] = useState([]);
  const [bankAccountName, setBankAccountName] = useState(null);

  useEffect(() => {
    async function fetchPropertyData() {
      try {
        const docRef = doc(db, 'properties', id);
        const snap = await getDoc(docRef);

        if (!snap.exists()) {
          setError(true);
          return;
        }

        const data = snap.data();

        // Enrich owners
        if (data.owners && Array.isArray(data.owners)) {
          const ownerDocs = await Promise.all(
            data.owners.map(uid => getDoc(doc(db, 'users', uid)))
          );
          const ownerNames = ownerDocs.map(d => d.exists() ? d.data().name : 'Unknown');
          setOwners(ownerNames);
        }

        // Enrich bank account
        if (data.bankAccount) {
          const bankSnap = await getDoc(doc(db, 'bankAccounts', data.bankAccount));
          if (bankSnap.exists()) {
            const b = bankSnap.data();
            setBankAccountName(`${b.name} • ****${b.last4}`);
          }
        }

        setProperty(data);
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    }

    fetchPropertyData();
  }, [id]);

  if (loading) return <p style={{ padding: 24 }}>Loading...</p>;
  if (error || !property) return <p style={{ padding: 24 }}>Property not found.</p>;

  const {
    address,
    city,
    state,
    zip,
    manager,
    balance = 52748,
    prepayments = 1269,
    depositsHeld = 0,
    rent = 1100,
  } = property;

  const fullAddress = `${address}, ${city}, ${state} ${zip}`;

  return (
    <PropertyDetailLayout
      address={fullAddress}
      owners={owners.join(' · ')}
      manager={manager}
      balance={balance}
      prepayments={prepayments}
      depositsHeld={depositsHeld}
      rent={rent}
      bankAccountName={bankAccountName}
    />
  );
}